import type {
  AOEAnswerT,
  AOEQuestionSchemaT,
  LabTestQuestionT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

export type AoeAnswersById = Record<string, string>;

export function toAoeAnswersArray(answersById: AoeAnswersById): AOEAnswerT[] {
  return Object.entries(answersById)
    .filter(([, answerCode]) => String(answerCode).trim() !== '')
    .map(([questionId, answerCode]) => ({
      question_id: questionId,
      answer_code: String(answerCode),
    }));
}

function getAllQuestions(schema: AOEQuestionSchemaT): LabTestQuestionT[] {
  return schema.sections.flatMap((s) => s.questions);
}

export function areRequiredQuestionsAnswered(
  schema: AOEQuestionSchemaT,
  answersById: AoeAnswersById
): boolean {
  const requiredQuestions = getAllQuestions(schema).filter((q) => q.body.required);
  return requiredQuestions.every((q) => {
    const value = answersById[q.id];
    return typeof value === 'string' && value.trim() !== '';
  });
}
